import { Button } from 'react-bootstrap';
import { FaFacebookF, FaPinterestP, FaPrint } from 'react-icons/fa';
import { useToast } from '../../../context/ToastContext';
import { openPdfPreview } from '../../../services/api';
import { LessonPlan, Recipe } from '../../../types/lessonPlan.type';
import RecipeCardFavorite from '../recipes/RecipeCardFavorite';
import './RecipeSocial.css';

interface RecipeSocialProps {
  recipe?: Recipe;
  lessonPlan?: LessonPlan | null;
}

const RecipeSocial: React.FC<RecipeSocialProps> = ({ recipe, lessonPlan }) => {
  const { addToast } = useToast();
  const currentUrl = window.location.href;
  const handleDownload = async () => {
    if (lessonPlan) {
      const id = lessonPlan.id ?? lessonPlan.slug;
      addToast('Preparing PDF…', 'info');
      try {
        await openPdfPreview(`lesson-plans/public/${id}/generate`);
      } catch (error) {
        const message = error instanceof Error ? error.message : '';
        addToast(
          message === 'Please allow pop-ups to preview the PDF'
            ? message
            : 'Unable to open lesson plan PDF. Please try again.',
          'error',
        );
      }
      return;
    }

    if (recipe) {
      addToast('Preparing PDF…', 'info');
      try {
        await openPdfPreview(`recipes/generate-recipe/${recipe.id}`);
      } catch {
        addToast('Unable to open recipe PDF. Please try again.', 'error');
      }
    }
  };
  return (
    <div className="recipe-social">
      <div>
        <a
          className="recipe-social-link ps-0"
          href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}
        >
          <FaFacebookF />
        </a>
        <a
          className="recipe-social-link"
          href={`http://pinterest.com/pin/create/button/?url=${currentUrl}`}
        >
          <FaPinterestP />
        </a>
      </div>












      <div className="d-flex">
        <RecipeCardFavorite
          recipe={recipe}
          lessonPlan={lessonPlan}
        />
        <Button
          className="recipe-button"
          variant="outline-primary"
          onClick={handleDownload}
        >
          <FaPrint className="button-icon" />
          Download/Print
        </Button>
      </div>
    </div>
  );
};

export default RecipeSocial;
